var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkingProfessional(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_868_6942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4238 5.69531V3.48074C12.3494 3.01987 14.6107 2.10938 18.0299 2.10938C20.3829 2.10938 22.1825 2.55322 23.2778 2.92566C23.8705 3.12726 24.327 3.32996 24.636 3.48322V5.69531H26.7454V2.2934L26.2716 1.98083C26.1491 1.89981 23.2111 0 18.0299 0C12.8485 0 9.91074 1.89981 9.78824 1.98083L9.31445 2.2934V5.69531H11.4238Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4119 24.6338V26.1134L18.0289 28.0612L13.6461 26.1134V24.6338H1.6543V36.0008H34.4034V24.6338H22.4119Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.492188 7.80469V22.5236H13.6467V19.1953H22.4124V22.5236H35.5666V7.80469H0.492188Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3038 21.3047H15.7568V24.7418L18.0302 25.7522L20.3038 24.7418V21.3047Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_868_6942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingProfessional);
export default __webpack_public_path__ + "static/media/working_professional.511b1d84acfbdb29fd099534ebf0b82b.svg";
export { ForwardRef as ReactComponent };